export function getJwtExpiration(token: string): Date | null {
  try {
    const payloadBase64 = token.split('.')[1];
    const payloadJson = atob(payloadBase64);
    const payload = JSON.parse(payloadJson);

    if (!payload.exp) return null;

    return new Date(payload.exp * 1000);
  } catch {
    return null;
  }
}
